import React from 'react'
import { SiteHeader } from '../../components/site-header'
import { SurveyAuth } from '../../components/survey/auth/survey-auth'
import { motion } from 'framer-motion'

export default function SurveyCreatePage() {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <div className="absolute inset-0 z-0 bg-background">
          <div className="relative w-full h-full">
            <img
              src="/images/backgrounds/flickr-21903280519.jpg"
              alt="Survey background"
              className="object-cover hero-bg w-full h-full"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-background/70 to-background" />
          </div>
        </div>
        
        <section className="container relative z-10 py-24">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="max-w-3xl mx-auto text-center space-y-6"
          >
            <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl">
              Create SLK Profile™ Survey
            </h1>
            <p className="text-xl text-muted-foreground">
              Sign in or create an account to manage surveys for your organization
            </p>
          </motion.div>
          <SurveyAuth />
        </section>
      </main>
    </div>
  )
}